<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Selection de l'état</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <mat-form-field>
                <mat-label>Etat de l'étape</mat-label>
                <mat-select [formControl]="stateControl" [(ngModel)]="data.selectedState" required>
                    @for (state of data.states; track state) {
                        <mat-option [value]="state">
                            {{ state.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="data" [disabled]="!stateControl.valid">Valider</button>
    </mat-card-actions>
</mat-card>
